export default "__VITE_ASSET__q270gyKG__"